import { render, staticRenderFns } from "./OssReactionsButton.vue?vue&type=template&id=13502ead&scoped=true"
import script from "./OssReactionsButton.vue?vue&type=script&lang=js"
export * from "./OssReactionsButton.vue?vue&type=script&lang=js"
import style0 from "./OssReactionsButton.vue?vue&type=style&index=0&id=13502ead&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13502ead",
  null
  
)

export default component.exports